/**
 * @generated SignedSource<<cc5469ba710b6e98acc6230b7c464be7>>
 * @relayHash 349d3fc916e4e88b5f32f16d75eee5cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c84dc2cc1bcca67c3a15eb97e519b9528f74819530e7b17577e9f2810b10a5a

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type overview_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type overview_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentIdentity_AtlassianCsmAgentIdentity">;
    } | null | undefined;
  } | null | undefined;
};
export type overview_agentIdentityQuery = {
  response: overview_agentIdentityQuery$data;
  variables: overview_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "agentIdentity_AtlassianCsmAgentIdentity"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "concreteType": "CsmAiAgentTone",
                        "kind": "LinkedField",
                        "name": "tone",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8c84dc2cc1bcca67c3a15eb97e519b9528f74819530e7b17577e9f2810b10a5a",
    "metadata": {},
    "name": "overview_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ad2118276853b2acba85a665b99d4060";

export default node;
